import * as types from '../mutation-types'
import { stateManager } from '../helper'
import { vuexfireMutations, firebaseAction } from 'vuexfire'
import api from '@/libs/api'
import ss from '@/libs/service-storage'
import * as MR from '@/libs/maybe-ramda'
import { fa } from '@/plugins/FirebaseAnalytics'
import * as R from 'ramda'

const sm = stateManager({
  dbState: null,
  cooldown: 0,
  ridi: {
    fetching: false,
    unlinking: false
  },
  millie: {
    fetching: false,
    unlinking: false
  }
})

export default {
  namespaced: true,
  state: sm.get(),
  mutations: {
    [types.SET_SERVICE_FETCHING] (state, { name, value }) {
      state[name].fetching = value
    },
    [types.SET_SERVICE_UNLINKING] (state, { name, value }) {
      state[name].unlinking = value
    },
    [types.COOLDOWN_SERVICE] (state) {
      state.cooldown = 10

      const tid = setInterval(() => {
        if (state.cooldown <= 0) {
          clearInterval(tid)
        }
        state.cooldown -= 1
      }, 1000)
    },
    ...vuexfireMutations
  },
  actions: {
    async import ({ commit, rootGetters }, { name, auth }) {
      fa.logEvent(fa.Event.IMPORT_BY_SERVICE, { name })
      commit(types.SET_SERVICE_FETCHING, { name, value: true })

      try {
        const token = await rootGetters.user.getIdToken()
        await api.services.import(token).send({ provider: name, auth })
        await ss.set(name, auth)
      } finally {
        commit(types.SET_SERVICE_FETCHING, { name, value: false })
        commit(types.COOLDOWN_SERVICE)
      }
    },
    async unlink ({ commit, dispatch, rootGetters }, { name, auth }) {
      fa.logEvent(fa.Event.UNLINK_SERVICE, { name })
      commit(types.SET_SERVICE_UNLINKING, { name, value: true })

      try {
        const token = await rootGetters.user.getIdToken()
        await api.services.unlink(token).send({ provider: name })
        await dispatch('clear')
      } finally {
        commit(types.SET_SERVICE_UNLINKING, { name, value: false })
        commit(types.COOLDOWN_SERVICE)
      }
    },
    async update ({ commit, rootGetters }, { name }) {
      fa.logEvent(fa.Event.UPDATE_BY_SERVICE, { name })
      let auth = null

      try {
        auth = await ss.get(name)
      } catch (e) {
        if (e.code === 1) {
          const err = new Error('service auth not found')
          err.code = 'AUTH_NOT_FOUND'
          throw err
        }

        throw e
      }

      commit(types.SET_SERVICE_FETCHING, { name, value: true })

      try {
        const token = await rootGetters.user.getIdToken()
        await api.services.import(token).send({ provider: name, auth })
      } finally {
        commit(types.SET_SERVICE_FETCHING, { name, value: false })
        commit(types.COOLDOWN_SERVICE)
      }
    },
    async clear () {
      await ss.clear()
    },
    setStateRef: firebaseAction(({ bindFirebaseRef }, ref) => {
      return new Promise((resolve, reject) => {
        bindFirebaseRef('dbState', ref).then(resolve).catch(reject)
      })
    })
  },
  getters: {
    ridiState (state) {
      const dbState = MR.of(state.dbState).chain(MR.prop('ridi')).getOrElse({})

      return R.merge(state.ridi, dbState)
    },
    millieState (state) {
      const dbState = MR.of(state.dbState)
        .chain(MR.prop('millie'))
        .getOrElse({})

      return R.merge(state.millie, dbState)
    },
    isWaiting (state) {
      return state.cooldown > 0
    },
    combinedState ({ ridi, millie }) {
      return {
        fetching: ridi.fetching || millie.fetching,
        unlinking: ridi.unlinking || millie.unlinking
      }
    }
  }
}
